"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Notifications Macroservice
 * A collection of services related to Notifications.  Includes send services (for outbound transactional notifications), and webhooks (for inbound updates related to previously sent notifications).    Future enhancements include support for outbound marketing emails and additional channels, like SMS.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfHealthControllerCheck200Response = instanceOfHealthControllerCheck200Response;
exports.HealthControllerCheck200ResponseFromJSON = HealthControllerCheck200ResponseFromJSON;
exports.HealthControllerCheck200ResponseFromJSONTyped = HealthControllerCheck200ResponseFromJSONTyped;
exports.HealthControllerCheck200ResponseToJSON = HealthControllerCheck200ResponseToJSON;
exports.HealthControllerCheck200ResponseToJSONTyped = HealthControllerCheck200ResponseToJSONTyped;
var runtime_1 = require("../runtime");
var health_controller_check200_response_info_value_1 = require("./health-controller-check200-response-info-value");
/**
 * Check if a given object implements the HealthControllerCheck200Response interface.
 */
function instanceOfHealthControllerCheck200Response(value) {
    return true;
}
function HealthControllerCheck200ResponseFromJSON(json) {
    return HealthControllerCheck200ResponseFromJSONTyped(json, false);
}
function HealthControllerCheck200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'] == null ? undefined : json['status'],
        'info': json['info'] == null ? undefined : ((0, runtime_1.mapValues)(json['info'], health_controller_check200_response_info_value_1.HealthControllerCheck200ResponseInfoValueFromJSON)),
        'error': json['error'] == null ? undefined : ((0, runtime_1.mapValues)(json['error'], health_controller_check200_response_info_value_1.HealthControllerCheck200ResponseInfoValueFromJSON)),
        'details': json['details'] == null ? undefined : ((0, runtime_1.mapValues)(json['details'], health_controller_check200_response_info_value_1.HealthControllerCheck200ResponseInfoValueFromJSON)),
    };
}
function HealthControllerCheck200ResponseToJSON(json) {
    return HealthControllerCheck200ResponseToJSONTyped(json, false);
}
function HealthControllerCheck200ResponseToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'info': value['info'] == null ? undefined : ((0, runtime_1.mapValues)(value['info'], health_controller_check200_response_info_value_1.HealthControllerCheck200ResponseInfoValueToJSON)),
        'error': value['error'] == null ? undefined : ((0, runtime_1.mapValues)(value['error'], health_controller_check200_response_info_value_1.HealthControllerCheck200ResponseInfoValueToJSON)),
        'details': value['details'] == null ? undefined : ((0, runtime_1.mapValues)(value['details'], health_controller_check200_response_info_value_1.HealthControllerCheck200ResponseInfoValueToJSON)),
    };
}
